<template>
  <div class="ScoreStep">
    <!-- 一般資訊 -->
    <div class="ScoreStep__main">
      <div class="ScoreStep__main__item">
        <div class="ScoreStep__main__item__pic">
          <img
            src="@/assets/雙人合盤/boy_left.svg"
            alt=""
            v-if="target1.Gender == 'M'"
          />
          <img src="@/assets/雙人合盤/girl_left.svg" alt="" v-else />
        </div>
        <div
          class="ScoreStep__main__item__name"
          @click="detailOpen = !detailOpen"
        >
          {{ target1.Name }}
        </div>
      </div>

      <div class="ScoreStep__main__info">
        <div class="ScoreStep__main__info__imgLeft">
          <img src="@/assets/雙人合盤/scoreStep_left.svg" alt="" />
        </div>
        <div class="ScoreStep__main__info__step">
          <!-- 百分比顯示圖 -->
          <percent-indicator :percentage="resonance" />
          <div class="ScoreStep__main__info__step__number">
            {{ animatedScore }}<span> 分</span>
          </div>
        </div>
        <div class="ScoreStep__main__info__textBottom">你们之间的共振度</div>
        <div class="ScoreStep__main__info__imgRight">
          <img src="@/assets/雙人合盤/scoreStep_right.svg" alt="" />
        </div>
      </div>

      <div class="ScoreStep__main__item">
        <div class="ScoreStep__main__item__pic">
          <img
            src="@/assets/雙人合盤/boy_right.svg"
            alt=""
            v-if="target2.Gender == 'M'"
          />
          <img src="@/assets/雙人合盤/girl_right.svg" alt="" v-else />
        </div>
        <div
          class="ScoreStep__main__item__name"
          @click="detailOpen = !detailOpen"
        >
          {{ target2.Name }}
        </div>
      </div>
      <div class="ScoreStep__main__openBtn" @click="detailOpen = !detailOpen">
        <img
          src="@/assets/icon_downward.svg"
          :style="detailOpen ? 'transform:rotate(180deg)' : ''"
        />
      </div>
    </div>
    <!-- 詳細資訊 -->
    <div class="ScoreStep__detail" v-if="detailOpen">
      <div class="ScoreStep__detail__birth">
        {{ `${target1.BirthPlace}` }}<br />
        {{ birthFormat(target1.BirthTime) }}
      </div>
      <div class="user__div"></div>
      <div class="ScoreStep__detail__birth">
        {{ `${target2.BirthPlace}` }}<br />
        {{ birthFormat(target2.BirthTime) }}
      </div>
    </div>
  </div>
</template>

<script>
import phaseMixin from "@/mixin/phaseMixin.js";
import PercentIndicator from "@/components/PercentIndicator.vue";

export default {
  mixins: [phaseMixin],
  components: {
    PercentIndicator,
  },
  props: {
    target1: {
      type: Object,
      default: () => {},
    },
    target2: {
      type: Object,
      default: () => {},
    },
    resonance: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      detailOpen: false,
      animatedScore: "00", // 用於顯示動畫的數字
    };
  },
  mounted() {
    // this.startScoreAnimation();
  },
  methods: {
    startScoreAnimation() {
      let counter = 0;
      const interval = setInterval(() => {
        // 生成隨機的兩位數字
        this.animatedScore = String(Math.floor(Math.random() * 100)).padStart(
          2,
          "0"
        );
        counter += 50; // 每次增加50毫秒
        if (counter >= 1500) {
          // 5秒後停止動畫
          clearInterval(interval);
          this.animatedScore =
            this.resonance == 100
              ? 100
              : String(this.resonance).padStart(2, "0"); // 顯示真正的數字
        }
      }, 40); // 每50毫秒更新一次
    },
  },
  watch: {
    resonance: {
      handler(newVal) {
        this.startScoreAnimation();
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/_mixin.scss";

.ScoreStep {
  width: 100%;
  padding: 32px 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: -2px -2px 8px 0 rgba(238, 109, 175, 0.22), -4px -4px 12px 0 rgba(238, 109, 175, 0.22),
    4px 4px 20px 0 rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  @include pad {
    padding: 0 24px;
    box-shadow: none;
  }
  .ScoreStep__main {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    position: relative;
    .ScoreStep__main__item {
      width: 93px;
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      @include mobile {
        width: 82px;
        margin-top: 53px;
      }
      .ScoreStep__main__item__pic {
        width: auto;
        height: 100px;
        @include mobile {
          height: 88px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .ScoreStep__main__item__name {
        margin-top: 8px;
        font-size: 19px;
        line-height: 1.5;
        color: #798da5;
        cursor: pointer;
        @include mobile {
          font-size: 15px;
        }
      }
    }
    .ScoreStep__main__info {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      &__textTop {
        font-size: 14px;
        line-height: 24px;
        color: #798da5;
        letter-spacing: 4%;
        @include mobile {
          line-height: 20px;
        }
      }
      &__step {
        position: relative;
        &__number {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-40%, -50%);
          font-size: 36px;
          line-height: 100%;
          color: #fa6363;
          font-weight: 700;
          @include mobile {
            font-size: 28px;
            line-height: 100%;
          }
          span {
            font-size: 14px;
            @include mobile {
              font-size: 14px;
            }
          }
        }
      }
      &__textBottom {
        font-size: 14px;
        line-height: 21px;
        color: #798da5;
        letter-spacing: 4%;
        margin-top: -0.5em;
        box-shadow: -1px -1px 4px 0 rgba(238, 109, 175, 0.22), -1px -1px 4px 0 rgba(238, 109, 175, 0.22),
          2px 2px 6px 0 rgba(0, 0, 0, 0.25);
        padding: 2px 8px;
        border-radius: 5px;
        @include mobile {
          border-radius: 5px;
          font-size: 12px;
          line-height: 19px;
          padding: 1px 8px;
          margin-top: -0.3em;
        }
      }
      .ScoreStep__main__info__imgLeft,
      .ScoreStep__main__info__imgRight {
        position: absolute;
        top: 50px;
        @include mobile {
          top: 70px;
        }
        img {
          width: 36px;
          @include mobile {
            width: 20px;
          }
        }
      }
      &__imgLeft {
        left: -60px;
        @include mobile {
          left: -28px;
        }
      }
      &__imgRight {
        right: -60px;
        @include mobile {
          right: -28px;
        }
      }
    }
    &__openBtn {
      position: absolute;
      right: -12px;
      bottom: 0;
      width: 24px;
      height: 24px;
      cursor: pointer;
      @include mobile {
        width: 20px;
        height: 20px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .ScoreStep__detail {
    display: flex;
    justify-content: space-between;
    width: 100%;
    .ScoreStep__detail__birth {
      font-size: 12px;
      color: #666666;
      text-align: center;
    }
  }
}

//共振度

.ScoreStep__main__info__step {
  svg {
    width: 120px;
    height: 120px;
  }

  .arc-bg {
    stroke: #f2f4f7;
    stroke-width: 10;
    fill: none;
    stroke-linecap: round;
  }

  .arc-fg {
    stroke: url(#gradient);
    stroke-width: 10;
    fill: none;
    stroke-linecap: round;
    transform: rotate(135deg);
    transform-origin: 50% 50%;
    filter: url(#shadow);
  }
}
</style>